import { ArrowBack } from "@mui/icons-material";
import { Box, Card, Divider, IconButton } from "@mui/material";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import Flex from "../../../../Flex";
import Text from "../../../../Text";

type PatientContentWrapProps = {
  children: ReactNode;
  title?: string;
  header?: ReactNode;
  endAction?: ReactNode;
  hideBackButton?: boolean;
};

const PatientContentWrap = ({
  children,
  title,
  header,
  endAction,
  hideBackButton = false,
}: PatientContentWrapProps) => {
  const navigate = useNavigate();

  return (
    <Card
      variant="outlined"
      sx={{
        // height: `calc(100vh - ${subHeader ? 148 : 145}px)`,
        width: "100%",
        height: "100%",
        // backgroundColor: "green",
      }}
    >
      <Flex width={"100%"} flexDirection={"column"} gap={1}>
        {title && (
          <Flex
            alignItems="center"
            justifyContent="space-between"
            sx={{
              height: 50,
              gap: "10px",
              pt: "8px",
              pr: "8px",
              pb: "8px",
              pl: "8px",
              borderBottom: "1px solid #E0E0E0",
            }}
          >
            <Flex alignItems="center" gap={"10px"}>
              {!hideBackButton && (
                <IconButton
                  size="small"
                  onClick={() => navigate("../index")}
                  sx={{ color: "#21262B" }}
                >
                  <ArrowBack fontSize="small" />
                </IconButton>
              )}
              <Text fontWeight={500} fontSize={16} color="#21262B">
                {title}
              </Text>
            </Flex>
            {!header && endAction && <Box sx={{ pr: 1 }}>{endAction}</Box>}
          </Flex>
        )}

        {header && (
          <Box width={"100%"} py={0.5}>
            <Flex
              width={"100%"}
              px={1}
              maxHeight={"40px"}
              minHeight={"40px"}
              alignItems={"center"}
              height={"100%"}
              justifyContent={"space-between"}
            >
              {header}
              {endAction && <Box sx={{ ml: "auto" }}>{endAction}</Box>}
            </Flex>
            <Divider sx={{ width: "100%", backgroundColor: "gray", mt: 0.5 }} />
          </Box>
        )}

        <Flex flex={1} px={1}>
          {children}
        </Flex>
      </Flex>
    </Card>
  );
};

export default PatientContentWrap;
